import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./MhAccessories.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const MhAccessories = () => {
  const { currentLang } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchAccessories = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/mheroAccessories?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to fetch MHERO Accessories:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAccessories();
  }, [currentLang]);

  if (loading || !data) return null;

  return (
    <section className="mhAccessories">
      {/* === Header === */}
      <div className="mhAccessories-header">
        <h1>{data.title}</h1>
        <p className="coming-soon">{data.subtitle}</p>
      </div>

      {/* === Grid === */}
      <div className="mhAccessories-grid">
        <div className="accessory-item">
          <img
            src={resolveUrl(data.image1)}
            alt={data.accessory1}
            loading="lazy"
          />
          <p>{data.accessory1}</p>
        </div>

        <div className="accessory-item">
          <img
            src={resolveUrl(data.image2)}
            alt={data.accessory2}
            loading="lazy"
          />
          <p>{data.accessory2}</p>
        </div>

        <div className="accessory-item">
          <img
            src={resolveUrl(data.image3)}
            alt={data.accessory3}
            loading="lazy"
          />
          <p>{data.accessory3}</p>
        </div>

        <div className="accessory-item">
          <img
            src={resolveUrl(data.image4)}
            alt={data.accessory4}
            loading="lazy"
          />
          <p>{data.accessory4}</p>
        </div>
      </div>

      {/* === Button === */}
      <Link to="/order" className="mhAccessories-btn">
        <button>BUILD your MHERO</button>
      </Link>
    </section>
  );
};

export default MhAccessories;
